import React, { useEffect } from 'react';
import { Box, Text, Button, useToast, Icon } from '@chakra-ui/react';
import { MdCheckCircle } from 'react-icons/md'; // Success icon

const SuccessAlert = ({ message, onClose }) => {
  const toast = useToast();

  useEffect(() => {
    if (message && !toast.isActive('success-toast')) {
      toast({
        id: 'success-toast',
        position: 'bottom',
        duration: 5000,
        isClosable: true,
        render: () => (
          <Box 
            color="white" 
            p={3} 
            bg="green.600" 
            borderRadius="md" 
            boxShadow="md"
            display="flex" 
            alignItems="center"
            mb={4} 
          >
            <Icon as={MdCheckCircle} w={6} h={6} mr={2} color="white" />
            <Text fontWeight="bold" flex="1">{message}</Text>
            <Button 
              size="sm" 
              ml={4} 
              colorScheme="green" 
              variant="outline" 
              onClick={onClose}
            >
              Close
            </Button>
          </Box>
        ),
      });
    }
  }, [message, onClose, toast]);

  return null; 
};

export default SuccessAlert;
